import { Reveal } from "../motion/Reveal";

export const Chapter = ({ no, eyebrow, title, text, className = "" }) => (
  <div className={`relative ${className}`} data-testid={`chapter-${no}`}>
    <div className="flex items-start gap-5 sm:gap-8">
      <Reveal y={20}>
        <span className="font-marcellus text-6xl sm:text-7xl lg:text-8xl leading-none nx-text-outline select-none" aria-hidden="true">{no}</span>
      </Reveal>
      <div className="pt-2 sm:pt-4">
        <Reveal delay={0.1}>
          <div className="flex items-center gap-4 mb-4">
            <span className="h-px w-10 bg-nx-gold/70" />
            <span className="text-[11px] tracking-[0.3em] uppercase text-nx-goldlight">{eyebrow}</span>
          </div>
        </Reveal>
        <Reveal delay={0.18}>
          <h2 className="font-marcellus text-3xl sm:text-4xl lg:text-5xl text-white leading-tight max-w-xl">{title}</h2>
        </Reveal>
        {text && (
          <Reveal delay={0.28}>
            <p className="mt-5 text-base md:text-lg text-slate-400 leading-relaxed max-w-xl">{text}</p>
          </Reveal>
        )}
      </div>
    </div>
  </div>
);
